import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { imageLazyLoad } from './utils/imageLazyLoad';
import './assets/styles/global.css';
// 关键修改：导入适用于 Vue3 的包
import VueViewer from 'v-viewer';  // 或 'vue3-v-viewer'
import 'viewerjs/dist/viewer.css';
import notify from '@/plugins/notify'
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'; // 正确名称



const app = createApp(App);
app.use(router);
const pinia = createPinia();

// 注册 Pinia
app.use(pinia);
pinia.use(piniaPluginPersistedstate); // 注册插件
// 注册插件（配置需在 use() 中传递）
app.use(notify)
app.use(VueViewer, {
  defaultOptions: {
    zoomable: true,
    scalable: true,
    rotatable: true,
    toolbar: true,
    zIndex: 9999  // 可选：防止被其他组件覆盖[3](@ref)
  }
});

app.directive('image-lazy', imageLazyLoad);
app.use(ElementPlus);
// 创建全局通知实例

app.mount('#app');


